const hasRequiredVariableValue = value => {
  return true
  if (value == null) return false
  if (typeof value === "string") return value.trim().length > 0
  return true
}

const isRequiredVariableForTemplate = ({ catalogEntry, isManagedPassTemplate = false }) => {
  if (!catalogEntry) return false

  if (catalogEntry.required_managed !== undefined || catalogEntry.required_standard !== undefined) {
    return Number(isManagedPassTemplate ? catalogEntry.required_managed : catalogEntry.required_standard) === 1
  }

  // Backward compatibility for older payloads
  if (catalogEntry.required !== undefined) return Number(catalogEntry.required) === 1

  return false
}

const validateRequiredVariableValue = ({ value, catalogEntry, label = "A value", isManagedPassTemplate = false }) => {
  if (!isRequiredVariableForTemplate({ catalogEntry, isManagedPassTemplate })) return { valid: true, helperText: "" }

  return hasRequiredVariableValue(value)
    ? { valid: true, helperText: "" }
    : { valid: false, helperText: `${label} is required.` }
}

export { hasRequiredVariableValue, isRequiredVariableForTemplate, validateRequiredVariableValue }
